import ChatLayout from "../layouts";
import Header from "./components/header";
import Footer from "./components/footer";
import Sidebar from "./components/sidebar";
import Icon from "common/components/icons";
import useChatRoom from "./hooks/useChatRoom";
import ProfileSection from "./components/profile";
import MessagesList from "./components/messages-list";
import SearchSection from "./components/search-section";
import {
  Container,
  Body,
  Background,
  FooterContainer,
  MainArea,
  ScrollButton,
} from "./styles";
import { useChatContext } from "pages/chat/context/chat";
import NewChatSection from "../components/new-chat";

export default function ChatRoomPage() {
  const {
    activeInbox,
    handleMenuOpen,
    handleShowIcon,
    isSearchOpen,
    isShowIcon,
    setIsSearchOpen,
    setShouldScrollToBottom,
    shouldScrollToBottom,
  } = useChatRoom();
  const chatCtx = useChatContext();

  return (
    <ChatLayout sidebarHidden={chatCtx.isMobileChatOpen}>
      <Container>
        <MainArea>
          <Body isHidden={!chatCtx.isMobileChatOpen}>
            <Background />
            <Header
              title={activeInbox?.name ?? ""}
              image={activeInbox?.image ?? "/assets/images/placeholder.jpeg"}
              subTitle={activeInbox?.role ?? (activeInbox?.isOnline ? "מקוון" : "")}
              onSearchClick={() => handleMenuOpen("search")}
              onProfileClick={() => {
                if (!activeInbox) {
                  return;
                }

                chatCtx.onOpenProfile({
                  about: activeInbox.role,
                  image: activeInbox.image ?? "/assets/images/placeholder.jpeg",
                  name: activeInbox.name,
                });
              }}
              onBack={() => chatCtx.onCloseChat()}
              showBack={chatCtx.isMobileChatOpen}
            />
            <MessagesList
              onShowBottomIcon={handleShowIcon}
              shouldScrollToBottom={shouldScrollToBottom}
            />
            <FooterContainer>
              {isShowIcon && (
                <ScrollButton onClick={() => setShouldScrollToBottom(true)}>
                  <Icon id="downArrow" />
                </ScrollButton>
              )}
              <Footer />
            </FooterContainer>
          </Body>
          <Sidebar title="חיפוש" isOpen={isSearchOpen} onClose={() => setIsSearchOpen(false)}>
            <SearchSection />
          </Sidebar>
          <Sidebar
            title="פרטי איש קשר"
            isOpen={chatCtx.isProfileOpen}
            onClose={() => chatCtx.onCloseProfile()}
          >
            <ProfileSection
              about={chatCtx.profileDetails?.about}
              name={chatCtx.profileDetails?.name ?? ""}
              image={chatCtx.profileDetails?.image ?? ""}
            />
          </Sidebar>
          <Sidebar
            title="שיחה חדשה"
            isOpen={chatCtx.isNewChatOpen}
            onClose={() => chatCtx.onToggleNewChat(false)}
          >
            <NewChatSection />
          </Sidebar>
        </MainArea>
      </Container>
    </ChatLayout>
  );
}
